import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function useScrollToAnchor() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    const target = document.querySelector(hash);

    if (target) {
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }, [hash, pathname]);
}
